import React from 'react';
import Menu from './menu';
import Sidebar from './sidebar';
import Footer from './footer';
import Microsoft from '../assets/microsoft.png'; // Import the image file
import People from '../assets/peoplelogo.jfif'; // Import the image file
import Himansu from '../assets/himansu.jfif'; // Import the image file
import azure from '../assets/azure.png'; // Import the image file
import share from '../assets/share.png'; // Import the image file
import Ecozera from '../assets/ecozera.png'; // Import the image file
import Azuredata from '../assets/dat eng.jfif'; // Import the image file
import techsp from '../assets/tech-sp.png'; // Import the image file



const Awards = () => {
return (
<div>
   <div class="container mt-5">
      <div class="row">
         <div class="col-sm-12 col-lg-3 col-xl-3 col-md-3">
            <Sidebar/>
         </div>
         <div class="col-sm-12 col-lg-9 col-xl-9 col-md-9">
            <Menu/>
            <div class="bostami-page-content-wrap">
               <section class="mb-5">
                  <div class="section-wrapper pl-60 pr-60 pt-60">
                     <div class="bostami-page-title-wrap mb-15">
                     <div class="three">
                                <h1 class="">Awards</h1>
                                </div>
                        <div class="row">
                           <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                           
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                              <div class="text-center">
                            <img class="mt-3 mb-3" src={Microsoft} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">CFT FinStant Award</h6>
                              <p class="year">(Mar 2022)</p>
                           </div>
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                              <div class="text-center">
                            <img class="mt-3 mb-3" src={Microsoft} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">CFT Quarterly Partnership Award </h6>
                              <p class="year">(Mar 2020)</p>
                           </div>

                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                        <div class="text-center">
                            <img class="mt-3 mb-3" src={People} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">Best PTGian </h6>
                              <p class="year">(Jun 2015 & Mar 2014)</p>
                           </div>
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                           <div class="text-center">
                            <img class="mt-3 mb-3" src={Himansu} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">Best Performer  </h6>
                              <p class="year">(Jun 2010)</p>
                           </div>
                           </div>



                           <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                           
                       
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                           <div class="text-center">
                            <img class="mt-3 mb-3" src={Microsoft} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">CFT Growth Mindset Award </h6>
                              <p class="year">(Dec 2022)</p>
                           </div>
                          
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                          
                          <div class="text-center">
                           <img class="mt-3 mb-3" src={Microsoft} style={{height:'50px',width:'50px'}}/>
                           </div>
                             <h6 class="awardname">Microsoft Excellence Award </h6>
                             <p class="year">(Jul 2017)</p>
                          
                       </div>
                       
                           
                          
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                           <div class="text-center">
                            <img class="mt-3 mb-3" src={Himansu} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">Best Customer Satisfaction </h6>
                              <p class="year">(Jan 2012)</p>
                           </div>
                        
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                           <div class="text-center">
                            <img class="mt-3 mb-3" src={Ecozera} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">Best EZian  </h6>
                              <p class="year">(Sep 2009)</p>
                           </div>
                      
                           </div>
                        </div>
                       
                        
                        <div class="three mt-5">
                                <h1 class="">Certificates</h1>
                                </div>
                        <div className="row mt-3">
                           <div class="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                         
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                           <div class="text-center">
                            <img class="mt-3 mb-3" src={azure} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">Azure Developer Associate </h6>
                              <p class="year">(2023)</p>
                           </div>
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                           <div class="text-center">
                            <img class="mt-3 mb-3" src={techsp} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">Technology Specialist </h6>
                              <p class="year">(2021)</p>
                           </div>
                         
                        </div>
                           <div class="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                          
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                           <div class="text-center">
                            <img class="mt-3 mb-3" src={Azuredata} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">Azure Data Engineer Associate</h6>
                              <p class="year">(2023)</p>
                           </div>
                           <div class="card text-center p-3 shadow-lg mt-5" style={{borderRadius:'25px',border:'none'}}>
                           <div class="text-center">
                            <img class="mt-3 mb-3" src={share} style={{height:'50px',width:'50px'}}/>
                            </div>
                              <h6 class="awardname">SharePoint Developer</h6>
                              <p class="year">(2019)</p>
                           </div>
                           </div>
                        </div>
                        
                       
                     </div>
                  </div>
               </section>
               <Footer/>
            </div>
         </div>
      </div>
   </div>
</div>
);
}
export default Awards;